const STORAGE_KEY = 'opificioai_recent_items';
const MAX_RECENT_ITEMS = 6;

/**
 * Recupera gli elementi recenti dal localStorage
 * @returns {Array} Array di elementi recenti
 */
export const getRecentItems = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.error('Error reading recent items from localStorage:', error);
        return [];
    }
};

/**
 * Aggiunge un elemento alla lista dei recenti
 * @param {Object} item - L'elemento da aggiungere {type: 'assistant'|'agent', id: string, name: string}
 */
export const addRecentItem = (item) => {
    try {

        if(!item || !item.type || !item._id) {
            console.error('Invalid item provided to addRecentItem:', item);
            return;
        }

        const recent = getRecentItems();

        // Rimuove l'elemento se già presente
        const filtered = recent.filter(
            r => !(r.type === item.type && r._id === item._id)
        );

        // Aggiunge il nuovo elemento all'inizio
        const updated = [
            {
                ...item,
                timestamp: Date.now()
            },
            ...filtered
        ].slice(0, MAX_RECENT_ITEMS); // Mantiene solo i primi MAX_RECENT_ITEMS

        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (error) {
        console.error('Error saving recent item to localStorage:', error);
    }
};

/**
 * Rimuove un elemento dalla lista dei recenti
 * @param {string} type - Tipo dell'elemento ('assistant' o 'agent')
 * @param {string} id - ID dell'elemento
 */
export const removeRecentItem = (type, _id) => {
    try {
        const recent = getRecentItems();
        const filtered = recent.filter(
            r => !(r.type === type && r._id === _id)
        );
        localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    } catch (error) {
        console.error('Error removing recent item from localStorage:', error);
    }
};

/**
 * Pulisce tutti gli elementi recenti
 */
export const clearRecentItems = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.error('Error clearing recent items from localStorage:', error);
    }
};
